<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br /> {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br /> Date: {{ date }}
        </p>
        <p> RE: Account #: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }} </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            I received your attempt to validate the debt that you are erroneously reporting about me. However, it does not meet any of the requested documentation required to satisfy validation of debt. How does this computer printout prove that this debt belongs to me? It shows nothing but my name, address, and a dollar amount. But I do not see my signature here or any of the other items requested from you. Perhaps I have been the victim of identity theft or fraud. I can certainly create similar documents on my computer, send them to your company and claim that you owe me money. Would that prove anything?
        </p>
        <p class="letter-content">
            You have failed to prove that this account is mine. I have documented my correspondence with you, and I will file complaints with the appropriate authorities if you do not remove this item from my credit report and cease all communications with me. Furthermore, if I find that this entry on my credit report later interferes with my ability to obtain credit with favorable terms, I will bring suit against your company as well as the original creditor for all applicable damages, as well as for statutory penalties provided under the FDCPA and FCRA.
        </p>
        <p class="letter-content">
            This will serve as your legal notice pursuant to the provisions of federal law, the Fair Debt Collection Practices Act (FDCPA), to cease all communication with me in regard to the debt referenced above, including the frivolous reporting of this account to any credit reporting agency. If you fail to heed this notice, I will file a formal complaint against you with the Federal Trade Commission, which is the federal agency responsible for enforcement, as well as the state Attorney General’s office.
        </p>
        <p class="letter-content">
            You are also notified that should any adverse information continue to be placed against my credit reports as a result of this notice, that appropriate actions will be taken. Please give this very important matter the attention it deserves.
        </p>
        <p>
            Thank you.
            <br />
            <br /> {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>